<template>
  <b-modal
    @show="onShow"
    dialog-class="md_modal_dialog_full3"
    modal-class="md_modal_full"
    content-class="md_modal_content_full"
    body-class="md_modal_body_full"
    header-class="dlg_header"
    :visible="visible"
    hide-footer
    hide-backdrop
    no-close-on-backdrop
    @hide="onCancel"
  >
    <template #modal-header="{close}">
      <div class="dlg_title1" style="flex: 1; text-align: center">{{dongInfo.dong}}{{$t('register.dong')}} {{hoName}}{{$t('register.ho')}}</div>
      <b-button class="dlg_close_btn" variant="white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
      </b-button>
    </template>
    <div class="full container" style="display: flex; flex-direction: column; padding: 0">
      <div class="flex_1" style="overflow-y: auto; padding: 0 15px 10px;">
        <div class="align-vertical" style="margin: 15px 10px">
          <md-form-group
            :label="$t('register.ho_name')" labelWidth="300">
            <div class="align-horizontal mb-2">
              <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="hoName" :formatter="formatStr1"
                            ref="_nameInput"
                            @focus="() => {self.showNameClear = hoName != ''}"
                            @blur="() => {self.showNameClear = false}" />
            </div>
          </md-form-group>
          <md-form-group
            :label="$t('map.trans_type')"
            :required="true"
            :enable_multi_select="true">
            <b-button
              variant="white"
              class="toggle_btn1 toggle_btn_text1"
              :class="{'ml-1': i == 1}"
              v-for="(v,k,i) in $c.TRANS_TYPE" v-if="v!=''" :key="k"
              :pressed="getMultipleState(i - 1, 'transType')"
              @click="() => {
            onMultiSelect(i - 1, 'transType');
          }">{{k}}</b-button>
          </md-form-group>
          <div v-show="transType.includes('0')"
               class="align-horizontal">
            <md-form-group :label="$t('register.trading_price')">
              <div class="align-horizontal">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="salePrice"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (site_inquire_price == 'Y')}"
                              :disabled="site_inquire_price == 'Y'"></b-form-input>
                <span class="input_caption1">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
            <div style="margin-right: 10px"></div>
            <md-form-group :label="$t('site_detail.collateral')" labelWidth="150">
              <div slot="checkbox_right" class="align-horizontal ml-2">
                <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="site_inquire_price" />
              </div>
              <div class="align-horizontal">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="collateralPrice"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (site_inquire_price == 'Y')}"
                              :disabled="site_inquire_price == 'Y'"></b-form-input>
                <span class="input_caption1">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
          </div>
          <md-form-group
            v-show="transType.split(',').includes('1')"
            :label="$t('map.charter_price')" labelWidth="300">
            <div slot="checkbox" class="align-horizontal ml-2">
<!--              <md-single-check-box :label="$t('map.safe_charter')" v-model="info.safe_charter" />-->
<!--              <md-single-check-box :label="$t('map.small_business')" v-model="info.smb" />-->
            </div>
            <div slot="checkbox_right" class="align-horizontal ml-2">
              <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="site_inquire_charter" />
            </div>
            <div class="align-horizontal mb-2">
              <b-form-input class="input_wrapper input mr-1 input_wrapper_sm"
                            v-model="charterPrice"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (site_inquire_charter == 'Y')}"
                            :disabled="site_inquire_charter == 'Y'"></b-form-input>
              <span class="input_caption mr-2">{{$t('room_info_popup.man_won')}}</span>
            </div>
          </md-form-group>
          <md-form-group
            v-show="transType.split(',').includes('2')"
            :label="$t('room_info_popup.invest')" labelWidth="300">
            <div slot="checkbox_right" class="align-horizontal ml-2">
              <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="site_inquire_investment" />
            </div>
            <div class="align-horizontal mb-2">
              <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="investmentPrice"
                            :formatter="u.formatNumber1"
                            :class="{'input_disabled' : (site_inquire_investment == 'Y')}"
                            :disabled="site_inquire_investment == 'Y'"></b-form-input>
              <span class="input_caption1 mr-2">{{$t('room_info_popup.man_won')}}</span>
            </div>
          </md-form-group>
          <div v-show="transType.split(',').includes('3')"
               class="align-horizontal">
            <md-form-group :label="$t('map.monthly_rent_deposit')">
              <div class="align-horizontal">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="monthlyRentDeposit"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (site_inquire_month == 'Y')}"
                              :disabled="site_inquire_month == 'Y'"></b-form-input>
                <span class="input_caption1">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
            <div style="margin-right: 10px"></div>
            <md-form-group :label="$t('interest.monthly')" labelWidth="150">
              <div slot="checkbox_right" class="align-horizontal ml-2">
                <md-single-check-box1 :label="$t('site_detail.site_inquire')" v-model="site_inquire_month" />
              </div>
              <div class="align-horizontal">
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm" v-model="monthlyRent"
                              :formatter="u.formatNumber1"
                              :class="{'input_disabled' : (site_inquire_month == 'Y')}"
                              :disabled="site_inquire_month == 'Y'"></b-form-input>
                <span class="input_caption1">{{$t('room_info_popup.man_won')}}</span>
              </div>
            </md-form-group>
          </div>
          <md-form-group
            :label="$t('map.room_nums')"
            :required="true"
            :enable_multi_select="false">
            <div class="align-horizontal">
              <b-button
                variant="white"
                class="toggle_btn1 toggle_btn_text1"
                :class="{'ml-1': idx == 0}"
                v-for="(val, idx) in $c.ROOM_NUM_SELECT.filter((it, _idx) => {return _idx > 0})" :key="idx"
                :pressed="self.room == idx"
                @click="() => {self.room = idx;self.room_more = '';}">{{val}}</b-button>
              <MFSelect
                class="btn toggle_btn1 toggle_btn_text1 ml-2"
                :class="{'active' : room > 4}"
                style="width: fit-content"
                :vmodel="room_more == '' ? $t('common.select') : room_more"
                :drop="true"
                @change="(value) => {
                  room_more = value == $t('common.select') ? '' : value
                  self.room = room_more != '' ? room_more : self.room
                }"
                :options="more_room_num_list"
              />
              <!-- <b-form-select class="toggle_btn1 toggle_btn_text1 ml-2"
                             :class="{'active' : room > 4}"
                             style="width: fit-content"
                             v-model="room_more"
                             @change="($event) => {self.room = room_more != '' ? room_more : self.room}">
                <option v-for="(val, idx) in more_room_num_list" :key="`room_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
              </b-form-select> -->
            </div>
          </md-form-group>
          <md-form-group
            :label="$t('map.toilet_nums')"
            :required="true"
            :enable_multi_select="false">
            <div class="align-horizontal">
              <b-button
                variant="white"
                class="toggle_btn1 toggle_btn_text1"
                :class="{'ml-1': idx == 0}"
                v-for="(val, idx) in Object.keys($c.MF_TOILET)" :key="idx"
                :pressed="self.toilet == $c.MF_TOILET[val]"
                @click="() => {self.toilet = idx + 1; self.toilet_more = ''}">{{val}}</b-button>
              <MFSelect
                class="btn toggle_btn1 toggle_btn_text1 ml-2"
                :class="{'active' : toilet > 3}"
                style="width: fit-content"
                :vmodel="toilet_more == '' ? $t('common.select') : toilet_more"
                :drop="true"
                @change="(value) => {
                  toilet_more = value == $t('common.select') ? '' : value
                  self.toilet = toilet_more != '' ? toilet_more : self.toilet
                }"
                :options="more_toilet_num_list"
              />
              <!-- <b-form-select class="toggle_btn1 toggle_btn_text1 ml-2"
                             :class="{'active' : toilet > 3}"
                             style="width: fit-content"
                             v-model="toilet_more"
                             @change="($event) => {self.toilet = toilet_more != '' ? toilet_more : self.toilet}">
                <option v-for="(val, idx) in more_toilet_num_list" :key="`toilet_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
              </b-form-select> -->
            </div>
          </md-form-group>
          <md-form-group
            :label="$t('room_info_popup.veranda')"
            :required="true"
            :enable_multi_select="false">
            <div class="align-horizontal">
              <b-button
                variant="white"
                class="toggle_btn1 toggle_btn_text1"
                :class="{'ml-1': idx == 0}"
                v-for="(val, idx) in Object.keys($c.VERANDA_UTILITY_NUM)" :key="idx"
                :pressed="self.veranda == $c.VERANDA_UTILITY_NUM[val]"
                @click="() => {self.veranda = idx; self.veranda_more = ''}">{{val}}</b-button>
              <MFSelect
                class="btn toggle_btn1 toggle_btn_text1 ml-2"
                :class="{'active' : veranda > 2}"
                style="width: fit-content"
                :vmodel="veranda_more == '' ? $t('common.select') : veranda_more"
                :drop="true"
                @change="(value) => {
                  veranda_more = value == $t('common.select') ? '' : value
                  self.veranda = veranda_more != '' ? veranda_more : self.veranda
                }"
                :options="more_veranda_num_list"
              />
              <!-- <b-form-select class="toggle_btn1 toggle_btn_text1 ml-2"
                             :class="{'active' : veranda > 2}"
                             style="width: fit-content"
                             v-model="veranda_more"
                             @change="($event) => {self.veranda = veranda_more != '' ? veranda_more : self.veranda}">
                <option v-for="(val, idx) in more_veranda_num_list" :key="`veranda_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
              </b-form-select> -->
            </div>
          </md-form-group>
          <md-form-group
            :label="$t('room_info_popup.utility_room')"
            :required="true"
            :enable_multi_select="false">
            <div class="align-horizontal">
              <b-button
                variant="white"
                class="toggle_btn1 toggle_btn_text1"
                :class="{'ml-1': idx == 0}"
                v-for="(val, idx) in Object.keys($c.VERANDA_UTILITY_NUM)" :key="idx"
                :pressed="self.utilityRoom == $c.VERANDA_UTILITY_NUM[val]"
                @click="() => {self.utilityRoom = idx; self.utility_more = ''}">{{val}}</b-button>
              <MFSelect
                class="btn toggle_btn1 toggle_btn_text1 ml-2"
                :class="{'active' : utilityRoom > 2}"
                style="width: fit-content"
                :vmodel="utility_more == '' ? $t('common.select') : utility_more"
                :drop="true"
                @change="(value) => {
                  utility_more = value == $t('common.select') ? '' : value
                  self.utilityRoom = utility_more != '' ? utility_more : self.utilityRoom
                }"
                :options="more_utility_room_num_list"
              />
              <!-- <b-form-select class="toggle_btn1 toggle_btn_text1 ml-2"
                             :class="{'active' : utilityRoom > 2}"
                             style="width: fit-content"
                             v-model="utility_more"
                             @change="($event) => {self.utilityRoom = utility_more != '' ? utility_more : self.utilityRoom}">
                <option v-for="(val, idx) in more_utility_room_num_list" :key="`utility_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
              </b-form-select> -->
            </div>
          </md-form-group>
          <md-form-group
            :label="$t('map.exclusive_area')">
            <div class="align-vertical">
              <div class="align-horizontal">
                <b-form-input class="input_wrapper input mr-2 input_wrapper_sm"
                              @input="($event) => {this.exclusiveSizePyong = u.calcPyong($event);}"
                              v-model="exclusiveSizeM2"></b-form-input>
                <span class="input_caption1 mr-2">{{`${$c.UNIT.square_meter} = `}}</span>
                <b-form-input class="input_wrapper input mr-1 input_wrapper_sm"
                              @input="($event) => {this.exclusiveSizeM2 = u.calcSquare($event);}"
                              v-model="exclusiveSizePyong"></b-form-input>
                <span class="input_caption1">{{$t('room_info_popup.pyong')}}</span>
              </div>
            </div>
          </md-form-group>
          <md-form-group
            :label="$t('site_detail.dup_teras1')"
            :required="true"
            :enable_multi_select="false">
            <div class="align-horizontal">
              <b-button
                variant="white"
                class="toggle_btn1 toggle_btn_text1 ml-1"
                :pressed="duplex == '' && teras == '' || duplex == 'N' && teras == 'N'"
                @click="() => {self.duplex = 'N'; self.teras = 'N'}">{{$t('map.none')}}</b-button>
              <b-button
                variant="white"
                class="toggle_btn1 toggle_btn_text1"
                :pressed="duplex == 'Y'"
                @click="() => {self.duplex = self.duplex == 'Y' ? 'N' : 'Y';}">{{$t('room_info_popup.duplex')}}</b-button>
              <b-button
                variant="white"
                class="toggle_btn1 toggle_btn_text1"
                :pressed="teras == 'Y'"
                @click="() => {self.teras = self.teras == 'Y' ? 'N' : 'Y';}">{{$t('site_detail.teras')}}</b-button>
            </div>
          </md-form-group>
          <!--        memo-->
          <div style="margin: 15px 5px 0 5px;">
            <div class="memo_input_wrapper" style="align-self: stretch">
              <b-form-textarea :placeholder="$t('register.ho_memo_hint')" rows="5" no-resize
                               class="memo full" style="padding: 8px" v-model="memo" ref="inputContent" />
            </div>
          </div>
          <!--        Individual site photos-->
          <div class="align-vertical" style="margin:15px 10px 0 10px">
            <div class="align-horizontal" style="align-items: center; margin: 10px 0px 10px 0px;">
              <div>
                <span class="caption" style="margin-bottom: 0">{{$t('room_info_popup.individual_photos')}}<br>
<!--                {{$t('room_info_popup.individual_photos2')}}-->
                </span>
              </div>
              <div style="flex: 1" />
              <div class="align-horizontal">
                <b-form-file multiple v-model="image" class="" accept="image/*" ref="imageBrowser"
                             style="display: none" @input="uploadImage(image)"></b-form-file>
                <b-button class="remove_img_btn btn_text" @click="onDeleteImage"
                          variant="secondary">
                  {{$t('common.delete')}}
                </b-button>
                <b-button class="attach_btn btn_text" variant="primary"
                          style="margin-left: 5px"
                          @click="$refs.imageBrowser.$el.querySelector('input[type=file]').click()">
                  {{$t('common.attach')}}
                </b-button>
              </div>
            </div>
            <div class="align-vertical" v-show="imageList.length > 0"
                 style="position: relative; margin-top: 10px;">
              <CCarousel
                ref="p_carousel"
                v-model="activeIndex"
                :interval="0"
                cStyle="text-shadow: 1px 1px 2px #333; z-index: 0"
              >
                <b-carousel-slide
                  v-for="img in imageList"
                  :img-src="img"
                >
                  <template slot="img">
                    <div class="slide-content" style="height: 480px">
                      <b-img
                        style="max-width: 100%; max-height: 100%;"
                        @click="onGallery()"
                        :src="img"
                      />
                    </div>
                  </template>
                </b-carousel-slide>
              </CCarousel>
            </div>
          </div>
        </div>
      </div>
      <div class="align-horizontal" style="align-self: stretch; margin-top: 5px;">
        <b-button variant="secondary" class="cancel_btn reg_btn_text no_border_radius" style="flex: 1" @click="onCancel">{{$t('common.cancel')}}</b-button>
        <b-button variant="primary" class="next_btn reg_btn_text no_border_radius" style="flex: 1" @click="onSave">{{$t('common.complete1')}}</b-button>
      </div>
    </div>
    <Gallery
      :visible.sync="galleryPopupShow"
      :src="imageList"
      :current="activeIndex"
    />
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
import MdSingleCheckBox from "../mf/MdSingleCheckBox";
import MdSingleCheckBox1 from "../mf/MdSingleCheckBox1";
import MFSelect from "../mf/MFSelect";
import CarouselIndicator from "../CarouselIndicator";
import Gallery from "../Gallery";
import CCarousel from "../CCarousel";
import MdFormGroup from "../MdFormGroup";

export default {
  name: "HouseholdEditPopup",
  components: {MdSingleCheckBox, MdSingleCheckBox1, CarouselIndicator, Gallery, CCarousel ,MdFormGroup, MFSelect},
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    _dongInfo: {
      type: Object,
      default: () => {},
    },
    _hoInfo: {
      type: Object,
      default: () => {},
    },
    _floor: {
      type: Number,
    },
    _transType: {
      type: String,
    },
    exclusiveSizeList: {
      type: Array,
      default: () => [],
    },
    realSizeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dongInfo: this._dongInfo != null ? this._dongInfo : {},
      floor: this._floor != null ? this._floor : -1,
      dongIndex: this._hoInfo != null ? this._hoInfo.dong_index : '',
      hoName: this._hoInfo != null ? this._hoInfo.ho : '',
      transType: this._hoInfo != null ? this._hoInfo.trans_type : '',
      site_inquire_price: this._hoInfo != null ? this._hoInfo.site_inquire_price : 'N',
      site_inquire_charter: this._hoInfo != null ? this._hoInfo.site_inquire_charter : 'N',
      site_inquire_investment: this._hoInfo != null ? this._hoInfo.site_inquire_investment : 'N',
      site_inquire_month: this._hoInfo != null ? this._hoInfo.site_inquire_month : 'N',
      safe_charter: this._hoInfo != null ? this._hoInfo.safe_charter : 'N',
      smb: this._hoInfo != null ? this._hoInfo.smb : 'N',
      room: this._hoInfo != null ? this._hoInfo.room : '0',
      room_more: (this._hoInfo == null || this._hoInfo && Number(this._hoInfo.room) < 5) ? '' : this._hoInfo.room,
      toilet: this._hoInfo != null ? this._hoInfo.toilet : '',
      toilet_more: (this._hoInfo == null || this._hoInfo && Number(this._hoInfo.toilet) < 4) ? '' : this._hoInfo.toilet,
      veranda: this._hoInfo != null ? this._hoInfo.veranda : 0,
      veranda_more: (this._hoInfo == null || this._hoInfo && Number(this._hoInfo.veranda) < 3) ? '' : this._hoInfo.veranda,
      utilityRoom: this._hoInfo != null ? this._hoInfo.utility_room : 0,
      utility_more: (this._hoInfo == null || this._hoInfo && Number(this._hoInfo.utility_room) < 3) ? '' : this._hoInfo.utility_room,
      duplex: this._hoInfo != null ? this._hoInfo.duplex : 'N',
      teras: this._hoInfo != null ? this._hoInfo.teras : 'N',
      exclusiveSizePyong: this._hoInfo != null ? this._hoInfo.exclusive_size : '',
      exclusiveSizeM2: this._hoInfo != null ? Utils.calcSquare(this._hoInfo.exclusive_size) : '',
      realSize: this._hoInfo != null ? this._hoInfo.real_size : '',
      salePrice: this._hoInfo != null && this._hoInfo.sale_price != '0' ? this._hoInfo.sale_price : '',
      charterPrice: this._hoInfo != null && this._hoInfo.charter_price != '0' ? this._hoInfo.charter_price : '',
      investmentPrice: this._hoInfo != null && this._hoInfo.investment_price != '0' ? this._hoInfo.investment_price : '',
      monthlyRent: this._hoInfo != null && this._hoInfo.monthly_rent != '0' ? this._hoInfo.monthly_rent : '',
      monthlyRentDeposit: this._hoInfo != null && this._hoInfo.monthly_rent_deposit != '0' ? this._hoInfo.monthly_rent_deposit : '',
      collateralPrice: this._hoInfo != null && this._hoInfo.collateral_price != '0' ? this._hoInfo.collateral_price : '',
      dongsiPrice: '',
      memo: this._hoInfo != null ? this._hoInfo.memo : '',
      imageList: this._hoInfo != null ? this._hoInfo.image_urls.split(',').filter(it => {
        return !Utils.isEmptyOrNull(it)
      }) : [],
      galleryPopupShow: false,
      image: null,
      activeIndex: 0,
      showLoading: false,
      showNameClear: false,
      showSaleClear: false,
      showCharterClear: false,
      self: this,
      u: Utils,
    }
  },
  created() {
  },
  computed: {
    data () {
      let data = [];
      let transType = this._transType;
      transType.split(',').filter(it => {
        return it != ''
      })
        .sort((a, b) => Number(a) - Number(b))
        .forEach(it => {
          if (this.$t('trans_type_ho').length > Number(it)) {
            data.push(this.$t('trans_type_ho')[Number(it)]);
          }
        });
      return data;
    },
    more_room_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_ROOM_CNT, 5))
    },
    more_toilet_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_TOILET_CNT, 4))
    },
    more_utility_room_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_UTILITY_ROOM_CNT, 3))
    },
    more_veranda_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_VERANDA_CNT, 3))
    },
  },
  methods:{
    getMultipleState(item, which)
    {
      return this[which].includes(String(item));
    },
    onMultiSelect (item, which) {
      item = item + "";
      let oldValue = this[which];
      oldValue = oldValue.split(',');
      if (oldValue.indexOf(item + '') > -1) {
        oldValue.splice(oldValue.indexOf(item), 1);
      } else {
        oldValue.push(item);
      }
      this[which] = oldValue.join(',')
    },
    formatStr1 (value) {
      let result = value.replace(new RegExp(/[^가-힣ㄱ-ㅎㅏ-ㅣ0-9a-zA-Z\-]/g), '');
      this.showNameClear = result != '';
      return result;
    },
    onShow() {
      Utils.setState(this,{
        dongsiPrice: Math.max(Number(this.salePrice), Number(this.charterPrice), Number(this.investmentPrice)) + ''
      });

    },
    onCancel() {
      this.$emit('onCancel');
    },
    uploadImage(file) {
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '1'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          Utils.setState(this,{
            imageList: this.imageList.concat(result.data.url)
          }, () => {
            this.activeIndex = this.imageList.length - 1;
          });
        } else {
          Utils.toast(this, result.msg);
        }
      })
        .catch((error) => {
          Utils.toast(this, this.$t('common.upload_image_error'));
        });
    },
    onDeleteImage() {
      let { imageList, activeIndex } = this;
      if (imageList.length <= 0) {
        return;
      }
      if (imageList.length - 1 < activeIndex) {
        return;
      }
      imageList.splice(activeIndex, 1);
      if (imageList.length == 0) {
        Utils.setState(this,{
          imageList: [],
          activeIndex: 0,
        });
        return;
      }
      if (activeIndex > imageList.length - 1) {
        activeIndex = imageList.length - 1
      }
      let self = this;
      Utils.setState(this,{
        imageList: imageList,
        activeIndex: activeIndex
      });
    },
    onGallery() {
      this.galleryPopupShow=true;
    },
    onSave() {
      let hoInfo = {
        dong_index: this.dongIndex,
        ho: this.hoName,
        floor: this.floor,
        trans_type: this.transType,
        room: this.room,
        toilet: this.toilet,
        veranda: this.veranda,
        utility_room: this.utilityRoom,
        duplex: this.duplex,
        teras: this.teras,
        exclusive_size: this.exclusiveSizePyong,
        real_size: this.realSize,
        sale_price: this.transType.includes('0') ? this.salePrice : '',
        collateral_price: this.transType.includes('0') ? this.collateralPrice : '',
        charter_price: this.transType.includes('1') ? this.charterPrice : '',
        investment_price: this.transType.includes('2') ? this.investmentPrice : '',
        monthly_rent: this.transType.includes('3') ? this.monthlyRent : '',
        monthly_rent_deposit: this.transType.includes('3') ? this.monthlyRentDeposit : '',
        site_inquire_price: this.site_inquire_price,
        site_inquire_charter: this.site_inquire_charter,
        site_inquire_investment: this.site_inquire_investment,
        site_inquire_month: this.site_inquire_month,
        safe_charter: this.safe_charter,
        smb: this.smb,
        memo: this.memo,
        image_urls: this.imageList.join(',')
      };
      if (Utils.isEmptyOrNull(this.transType)) {
        Utils.toast(this, this.$t('register.trans_type_placeholder'));
        return;
      }
      if (this.transType.split(',').includes('0')) {
        if (this.site_inquire_price == 'Y') {
          this.salePrice = 0
          this.collateralPrice = 0
        } else {
          if (Utils.isEmptyOrNull(this.salePrice)) {
            Utils.toast(this, this.$t('register.trans_cost_placeholder1'));
            return;
          }
        }
      } else {
        this.salePrice = 0;
        this.collateralPrice = 0;
        this.site_inquire_price = 'N';
      }
      if (this.transType.split(',').includes('1')) {
        if (this.site_inquire_charter == 'Y')
          this.charterPrice = 0;
        else {
          if (Utils.isEmptyOrNull(this.charterPrice)) {
            Utils.toast(this, this.$t('register.trans_cost_placeholder1'));
            return;
          }
        }
      } else {
        this.site_inquire_charter = 'N'
        this.charterPrice = 0
      }
      if (this.transType.split(',').includes('2')) {
        if (this.site_inquire_investment == 'Y')
          this.investmentPrice = 0;
        else {
          if (Utils.isEmptyOrNull(this.investmentPrice)) {
            Utils.toast(this, this.$t('register.trans_cost_placeholder1'));
            return;
          }
        }
      } else {
        this.investmentPrice = 0;
        this.site_inquire_investment = 'N';
      }
      if (this.transType.split(',').includes('3')) {
        if (this.site_inquire_month == 'Y') {
            this.monthlyRent = 0
            this.monthlyRentDeposit = 0
        } else {
          if (Utils.isEmptyOrNull(this.monthlyRent) || Utils.isEmptyOrNull(this.monthlyRentDeposit)) {
            Utils.toast(this, this.$t(''))
            return;
          }
        }
      } else {
        this.monthlyRent = 0;
        this.monthlyRentDeposit = 0;
        this.site_inquire_month = 'N';
      }
      if (Utils.isEmptyOrNull(this.room)) {
        Utils.toast(this, this.$t('register.room_num_placeholder'))
        return;
      }
      if (Utils.isEmptyOrNull(this.toilet)) {
        Utils.toast(this, this.$t('register.toilet_num_placeholder'))
        return;
      }
      this.$emit('onSave', hoInfo);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
//@import "../../../assets/css/main/more/RegNewOpenSite1";

.col {
 padding-right: 0;
 padding-left: 0;
}
.active {
  color: $c_457fff !important;
  border-color: $c_457fff !important;
}
.header {
  height: 46px;
  align-items: center;
  justify-content: center;
  border-bottom-width: 1px;
  border-bottom-color: #f2f1f1;
}
.title {color: $text; font-size: $fs_16}
.btn_text {color: white; font-size: $fs_14; font-family: $korean_gd_14_r}
.input_wrapper {
  border-width: 0.5px;
  border-color: #bebdbd;
  border-radius: 3px;
  //padding-left: 8px;
  //padding-right: 8px;
  //height: 30px;
  align-items: center;
}
.space {width: 80px; margin-right: 2px; margin-left: 5px; text-align: center;}
.caption {color: black; font-size: $fs_18; font-family: $korean_gd_15_r; text-align: center}
.caption1 {color: black; font-size: $fs_22; font-family: $korean_gd_17_r; padding-left: 4px;}
.input {
  //width: 100%;
  display: flex;
  align-items: center;
  color: $black;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
  //padding: 0;
  //border-width: 0!important;
  margin-left: 5px;
}
.input1 {
  display: flex;
  align-items: center;
  color: black;
  font-size: $fs_20;
  font-family: $korean_gd_14_r;
  padding: 5px 10px;
  height: 50px;
  text-align: center;
}
.input_wrapper_sm {
  width: 100px;
  text-align: center;
}
.memo {color: black; font-size: $fs_16; font-family: $korean_gd_13_r; line-height: 30px}
.input_caption {color: #666666; font-size: $fs_12; font-family: $korean_gd_13_r}
.input_caption1 {
  color: #666666;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
}
.multi_select {
  position: absolute;
  color: #ccc9c9;
  font-size: 15px;
  top: 22px;
  font-family: $korean_gd_13_r
}
.toggle_btn {
  height: 40px;
  width: 50px;
  border-width: 1px;
  border-radius: 5px;
  border-color: #bebdbd;
  background-color: transparent;
  justify-content: center;
  padding: 0px 3px 0px 3px;
}
.toggle_btn_active {border-color: $primary}
.toggle_btn_text {
  text-align: center;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
  color: #7d7d7d;
}
.toggle_btn_active_text {color: $primary}
.toggle_btn1 {
  height: 40px;
  border-width: 0.5px;
  border-radius: 5px;
  border-color: #eeeeef;
  background-color: transparent;
  padding-top: 0;
  padding-bottom: 0;
  justify-content: center;
  margin-right: 8px;
  margin-bottom: 8px;
}

.toggle_btn1.active {
  border-color: $primary !important;
  color: $primary !important;
}
.toggle_btn_text1 {
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
  color: #7d7d7d;
}
.memo_input_wrapper {border-width: 1px; border-color: #eeeeef; border-radius: 5px; justify-content: center}

.attach_btn {
  width: 75px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: $c_457fff;
  border-radius: 3px;
}
.remove_img_btn {
  width: 75px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: $trading1;
  border-radius: 3px;
}
.carousel_wrapper {margin-top: -10px; margin-left: 12px; margin-right: 12px; height: 305px}
.pagination_wrapper {position: absolute; width: 100%; bottom: 0; padding-top: 0; padding-bottom: 0}
.pagination_dots {margin-left: -4px; margin-right: -4px;}
.next_btn {height: 50px; background-color: $c_457fff; align-items: center; justify-content: center}
.cancel_btn {height: 50px; background-color: #cacbcd; align-items: center; justify-content: center}
.reg_btn_text {font-size: $fs_18; font-family: $korean_gd_15_r; color: white;}
.check_text {color: $black; font-size: $fs_14; font-family: $korean_gd_14_r; margin-right: 0}
.contain_desc {position: relative;}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/HouseholdEditPopup.vue